import { Component, OnInit} from '@angular/core';
import {BusinessProfile} from '../../../../model/account';
import {ApiService} from '../../../../service/api.service';
import {AuthService} from '../../../../service/auth.service';

@Component({
  selector: 'app-sign-in-select-profile',
  templateUrl: './sign-in-select-profile.component.html',
  styleUrls: ['./sign-in-select-profile.component.scss']
})
export class SignInSelectProfileComponent implements OnInit {
  loading = true;
  bpByEntities: BpByEntity[];

  private static sortBpByLevel(businessProfiles: BusinessProfile[]): BusinessProfile[] {
    return businessProfiles.sort((a, b) => a.level - b.level);
  }

  private static sortBpByAlphabeticalOrder(businessProfiles: BusinessProfile[]): BusinessProfile[] {
    return businessProfiles.sort((a, b) => a.name.localeCompare(b.name));
  }

  private static getBpByEntity(businessProfiles: BusinessProfile[]): BpByEntity[] {
    businessProfiles = SignInSelectProfileComponent.sortBpByLevel(businessProfiles);
    const bpByEntities = businessProfiles.map(businessProfile => {
      return {
        entityId: businessProfile.entityId,
        entityName: businessProfile.entityName,
        businessProfiles: SignInSelectProfileComponent.sortBpByAlphabeticalOrder(
          businessProfiles.filter(curBusinessProfile => curBusinessProfile.entityId === businessProfile.entityId)
        )
      };
    });

    return bpByEntities.reduce(
      (resBpByEntities, bpByEntity) => {
        return !!!resBpByEntities
          .find(curBpByEntity => curBpByEntity.entityId === bpByEntity.entityId) ? [...resBpByEntities, bpByEntity] : resBpByEntities;
      },
      [bpByEntities[0]]
    );
  }

  constructor(private apiService: ApiService, private authService: AuthService) {}

  ngOnInit() {
    this.loading = true;

    this.apiService.account().subscribe(account => {
      this.loading = false;
      if (account.businessProfiles?.length > 0) {
        this.bpByEntities = SignInSelectProfileComponent.getBpByEntity(account.businessProfiles);
      }
    });
  }

  selectBusinessProfile(businessProfile: BusinessProfile) {
    this.authService.selectBusinessProfile(businessProfile);
  }
}

class BpByEntity {
  entityId: string;
  entityName: string;
  businessProfiles: BusinessProfile[];
}

